<div class="mt-5 pb-5">
          <button class="btn btn-secondary mx-1" title="Retour au questionnaire"
          (click)="retourSaisie()">
          <i class="material-icons md-18 mr-1" aria-hidden="true">edit</i>Retour Saisie</button>

          <h1 class="mt-4 text-center align-middle">Déclaration d’accessibilité</h1>
          <p class="mt-4">Le SSER s'engage à rendre l'enquête en ligne sur l'activité des Associations d'Aide aux Victimes accessible conformément 
               à l'article 47 <br> de la loi n° 2005-102 du 11 février 2005.</p>
          <p class="mt-2">A cette fin, il met en oeuvre la stratégie et les actions suivantes :</p>     
          <ul>
               <li>En 2024, les équipes métiers et informatiques ont suivi des formations sur l'accessibilité numérique;</li>
               <li>En 2025, l'équipe informatique définira les modalités techniques et organisationnelles de réalisation d'un audit d'accessibilité;</li>
               <li>En 2026, il est prévu la réalisation effective d'un audit d'accessibilité et l'élaboration d'un plan d'actions d'améliorations de l'accessibilité du site.</li>
          </ul>
          <p class="mt-2">Cette déclaration d'accessibilité s'applique à l'enquête en ligne sur l'activité des Associations d'Aide aux Victimes.</p>

          <h2 class="mt-5">État de conformité</h2>
          <p>L'enquête en ligne sur l'activité des Associations d'Aide aux Victimes est non conforme car elle n'a pas fait l'objet d'un audit de conformité au RGAA.</p>
          
          <h2 class="mt-5">Établissement de cette déclaration d’accessibilité</h2>
          <p>Cette déclaration a été établie le 27 janvier 2025.</p>

          <h3 class="mt-4">Technologies utilisées pour la réalisation du site</h3>
          <ul>
               <li>HTML</li>
               <li>CSS</li>
               <li>JavaScript</li>
               <li>Angular</li>
               <li>Bootstrap</li>
          </ul>

          <h2 class="mt-5">Retour d’information et contact</h2>
          <p>Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter la Section Enquêtes du SSER
               pour être orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.</p>
          <ul>
               <li>Envoyer un courriel : <a href="mailto:stats-enquetes.ssmjustice@justice.gouv.fr?Subject=Enquête%20Aav">
                    stats-enquetes.ssmjustice&#64;justice.gouv.fr
                  </a></li>
          </ul>

          <h2 class="mt-5">Voies de recours</h2>
          <p>cette procédure est à utiliser dans le cas suivant :</p>
          <p>Vous avez signalé au responsable du site internet un défaut d’accessibilité qui vous empêche d’accéder à un contenu 
               ou à un des services du portail et vous n’avez pas obtenu de réponse satisfaisante.</p>
          <ul>
               <li>Écrire un message au Défenseur des droits : 
                    <a href="https://www.defenseurdesdroits.fr/nous-contacter-355">
                         https://www.defenseurdesdroits.fr/nous-contacter-355
                    </a>
               </li>
               <li>Contacter le délégué du Défenseur des droits près de chez vous : 
                    <a href="https://www.defenseurdesdroits.fr/carte-des-delegues">
                         https://www.defenseurdesdroits.fr/carte-des-delegues
                    </a>
               </li>
               <li>Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) : Défenseur des droits Libre réponse 71120 75342 Paris CEDEX 07</li>
          </ul>
</div>

